module.exports = __webpack_public_path__ + "static/media/investpic2@3x.26543b86.png";